var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('my-head'),_c('div',{staticClass:"minH recruit"},[_vm._m(0),_c('div',{staticClass:"title flex-center"},[_vm._v(_vm._s(_vm.data.title))]),_c('el-divider'),_c('div',{domProps:{"innerHTML":_vm._s(_vm.data.content)}})],1),_c('my-footer')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"crumbs"},[_vm._v(" 首页 > 关于我们 > 信息公开 > "),_c('span',{staticStyle:{"color":"#1d2129"}},[_vm._v("招聘信息")])])
}]

export { render, staticRenderFns }